import genericRule from '../../namespace/relation/doingRemove_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'savedFilter'
};
